import React from 'react'
import Helper, { ActivityAction } from 'utils/Helper.class'
import {
  GroupMeta,
  IAbstractSearchItem,
  UserSearchItem,
} from 'lib/graphql/graphqlTypes'
import TextLink from '@bit/atd.web.text-link/dist/TextLink'

type PropsType = {
  action: ActivityAction
  content?: IAbstractSearchItem | null
  groupMeta?: GroupMeta | null
}

/**
 *
 * @param action
 * @param content
 * @param groupMeta
 */
const NetWorkActionLabelFormatter = ({
  action,
  content,
  groupMeta,
}: PropsType) => {
  if (action === 'GROUP' && groupMeta) {
    let phrase = ''
    switch (groupMeta.groupAction) {
      case 'JOINED_BY':
        phrase = 'Has now joined '
        break
      case 'REQUESTED':
        phrase = 'Requested to join group '
        break
      case 'JOINED_TO':
        phrase = 'Has now joined '
        break
      case 'REJECTED':
        phrase = 'Was rejected from '
        break
      case 'PENDING':
        phrase = 'Pending request to join '
        break
    }
    return (
      <>
        {phrase}{' '}
        <TextLink href={groupMeta.groupUrl}>{groupMeta.groupName}</TextLink>
      </>
    )
  }

  if (!content?.contentTypes?.lvl0 || !content) {
    return <></>
  }
  const contentType = `${content?.contentTypes?.lvl0}`
  const article = `${Helper.articleChooser(content?.contentTypes?.lvl0)}`
  const actionText = Helper.actionTextHelper(action)

  if (action === 'COMMENT') {
    return (
      <>
        {actionText} <b>{contentType}</b>
      </>
    )
  }

  if (contentType === 'People') {
    const user = content as UserSearchItem
    return (
      <>
        {actionText}
        <b>
          {user.firstName} {user.lastName}
        </b>
      </>
    )
  }

  return (
    <>
      {actionText} {article} <b>{contentType}</b>
    </>
  )
}

export default NetWorkActionLabelFormatter
